import { Avatar, AvatarGroup } from "@etframework/ui.components";
import { useTranslation } from "react-i18next";
import "moment/dist/locale/es-us";
import moment from "moment-timezone";
import { formatDate } from "../../utils/helpers";

export const CardListItem = ({ board, id, onClick }) => {
  const { t, i18n } = useTranslation(["SettingsLayout"], {
    useSuspense: false,
  });
  moment.locale(i18n.language);
  return (
    <div id={id} onClick={() => onClick(board?.Id)}>
      <div className="boards-list-item">
        <div className="col">
          <div className="boards-list-name">{board?.Name}</div>
          <div>{board?.Description}</div>
        </div>
        <div className="col">
          <div className="fw-bold mb-1">{t("CardListItems.Collaborators")}</div>
          <div className="ps-3">
            {board?.Permissions && (
              <AvatarGroup
                id={id + "_user-permissions-avatar-group"}
                total={board?.Permissions?.length ?? 0}
                max={3}
                onClick={() => {}}
              >
                {board?.Permissions?.map((user, i) => (
                  <Avatar key={i} content={user.FullName}></Avatar>
                ))}
              </AvatarGroup>
            )}
          </div>
        </div>
        <div className="col">
          <div
            id={id + "_task-types-count"}
            className="boards-list-count text-end"
            onClick={() => {}}
          >
            {t("CardListItems.TaskTypes", { count: board?.TaskTypesCount })}
          </div>
          <div className="boards-list-date text-end">
            {board.Archived
              ? board?.ArchivedAt &&
                `${t("CardListItems.Archived")} ${formatDate(
                  board.ArchivedAt,
                  "ll, LT"
                )}`
              : board?.UpdatedDate &&
                `${t("CardListItems.Updated")} ${formatDate(
                  board.UpdatedDate,
                  "ll, LT"
                )}`}
          </div>
        </div>
      </div>
    </div>
  );
};
